import {Vector3} from 'three';
import {RAYCAST_MAX_DIST} from 'lib';

interface IRaycastCamHeightPoint {
  lastKnownY: number;
  targetPos: Vector3;
  cameraPos: Vector3;
}

/**
 * @returns newPosition as the raycasted position restricted by camera height.
 */

const raycastCamHeightPoint = ({lastKnownY, targetPos, cameraPos}: IRaycastCamHeightPoint) => {
  const localX = targetPos.x - cameraPos.x;
  const localY = targetPos.y - cameraPos.y;
  const localZ = targetPos.z - cameraPos.z;

  const localYPrime = lastKnownY - cameraPos.y;
  const localXPrime = (localX / localY) * localYPrime;
  const localZPrime = (localZ / localY) * localYPrime;

  const newX = localXPrime + cameraPos.x;
  const newZ = localZPrime + cameraPos.z;

  let finalX = newX;
  let finalZ = newZ;

  // Check for max distance.
  const squaredNewX = newX ** 2;
  const squaredNewZ = newZ ** 2;
  if (squaredNewX + squaredNewZ > RAYCAST_MAX_DIST ** 2) {
    const distance = Math.sqrt(squaredNewX + squaredNewZ);
    const ratio = distance / RAYCAST_MAX_DIST;
    finalX = newX / ratio;
    finalZ = newZ / ratio;
  }

  const newPosition = [finalX, lastKnownY, finalZ];

  return {newPosition};
};

export default raycastCamHeightPoint;
